import { MenuObjectTypes } from 'enums/menu';
import { SectionUiPattern } from 'state/menu/types';

type MenuNode = {
  _type?: string;
  uiPattern?: string;
  options?: Array<MenuNode | null | undefined> | null;
};

const PRICED_ITEM_TYPES = new Set<string>([
  MenuObjectTypes.ITEM,
  MenuObjectTypes.COMBO,
  MenuObjectTypes.PICKER,
]);

const isPricedMenuItemType = (type?: string): boolean =>
  Boolean(type && PRICED_ITEM_TYPES.has(type));

const optionShowsItemPrices = (option: MenuNode): boolean => {
  if (isPricedMenuItemType(option._type)) {
    return true;
  }

  if (option._type !== MenuObjectTypes.SECTION) {
    return false;
  }

  const isItemListPattern =
    option.uiPattern === SectionUiPattern.STACKED ||
    option.uiPattern === SectionUiPattern.INLINE_TILE;

  if (!isItemListPattern) {
    return false;
  }

  return (option.options ?? []).some(child => child != null && isPricedMenuItemType(child._type));
};

/**
 * Menu tiles only render prices for items / combos / pickers.
 * Nested standard sections are subcategory tiles with no prices, so those
 * screens must not show the US delivery price disclaimer.
 */
export const menuSectionShowsItemPrices = (menuData?: MenuNode | null): boolean => {
  if (menuData?._type !== MenuObjectTypes.SECTION) {
    return false;
  }

  return (menuData.options ?? []).some(option => option != null && optionShowsItemPrices(option));
};
